
import React from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import PartnerListing from '@/components/partners/PartnerListing';
import ConnectionWarning from '@/components/ConnectionWarning';

const Psychologists = () => {
  return (
    <>
      <Helmet>
        <title>Psychologists | Career Guide Kerala</title>
      </Helmet>
      
      <div className="flex flex-col min-h-screen">
        <Navbar />
        
        <main className="flex-1">
          <div className="container mx-auto px-4 py-8">
            <ConnectionWarning />
            <PartnerListing associationType="Psychologist" />
          </div>
        </main>
        
        <Footer />
      </div>
    </>
  );
};

export default Psychologists;
